import { useEffect, useState } from 'react';

const useMediaQuery = (query) => {
    const [matches, setMatches] = useState(false);

    useEffect(() => {
        const mediaQuery = window.matchMedia(query);

        const handleChange = (event) => {
            setMatches(event.matches);
        };

        // Vérifie au chargement
        setMatches(mediaQuery.matches);

        // Écoute les changements
        mediaQuery.addEventListener('change', handleChange);

        // Nettoyage
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, [query]);

    return matches;
};

export default useMediaQuery;